// TODO: scroll anchor
export default [
  {
    route: '/',
    label: 'Главная',
  },
  {
    route: '/services',
    label: 'Услуги центра',
  },
  {
    // route: '#feedback',
    route: '/testimonials',
    label: 'Отзывы',
  },
  // {
  //   route: '#specialists',
  //   // route: '/specialists',
  //   label: 'Специалисты'
  // },
  {
    route: '/school',
    label: 'Обучение',
  },
  {
    route: '/faq',
    // route: '/questions',
    label: 'Ответы',
  },
  // {
  //   route: '/beauty-shop',
  //   label: 'Бьютишоп'
  // },
];
